import React, { useEffect, useState } from 'react'
import { MinusIcon, PlusIcon } from '@heroicons/react/outline'
import { FormatAmount } from './FormatAmount';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { returnOrder } from '../Redux/Action/order.action';

const RefundProduct = ({ orderData, handleClosePopup, selectedProduct, setSelectedProduct, productInfo, setProductInfo }) => {
    const dispatch = useDispatch();
    const { staffInfo } = useSelector((state) => state.authReducer)
    const filteredProduct = orderData?.products?.filter(item => new Date(item?.return_valid_till_date) >= new Date() && !item?.is_return)
    const [paymentMethod, setPaymentMethod] = useState('');
    useEffect(() => {
        if (orderData?.cash_amount) {
            setPaymentMethod('cash')
        } else if (orderData?.digital_amount) {
            setPaymentMethod('digital')
        } else if (orderData?.cash_amount && orderData?.digital_amount) {
            setPaymentMethod('cash')
        }
    }, [orderData])
    const handleProduct = (e, v) => {
        setSelectedProduct(v);
        setProductInfo((prevProductInfo) => {
            const updatedProductInfo = v.map((elem) => {
                const existingProduct = prevProductInfo.find(
                    (product) => product.id === elem?.product
                );
                return {
                    product: elem?.product,
                    qty: elem?.quantity,
                    name: elem?.name,
                    selling_price: elem?.selling_price,
                    discount_amount: elem?.discount_amount,
                    quantity: existingProduct?.quantity || 1,
                    reason: existingProduct?.reason || '',
                    comment: existingProduct?.comment || '',
                    return_quantity: existingProduct?.return_quantity ?? true,
                };
            });
            const uniqueProductInfo = updatedProductInfo.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => t.product === item.product)
            );

            return uniqueProductInfo;
        });
    };
    const qtyCounter = (data, increment) => {
        const updatedProducts = productInfo?.map((product) => {
            if (product.product === data.product) {
                const newQuantity = increment ? product.quantity + 1 : Math.max(product.quantity - 1, 1);
                return {
                    ...product,
                    quantity: newQuantity,
                };
            }
            return product;
        });
        setProductInfo(updatedProducts)
    }
    const handleReason = (data, e) => {
        const updatedProducts = productInfo?.map((product) => {
            if (product.product === data.product) {
                return {
                    ...product,
                    reason: e.target.value,
                };
            }
            return product;
        });
        setProductInfo(updatedProducts)
    }
    const handleComment = (data, e) => {
        const updatedProducts = productInfo?.map((product) => {
            if (product.product === data.product) {
                return {
                    ...product,
                    comment: e.target.value,
                };
            }
            return product;
        });
        setProductInfo(updatedProducts)
    }
    const handleReturnQuantity = (data, e) => {
        const updatedProducts = productInfo?.map((product) => {
            if (product.product === data.product) {
                return {
                    ...product,
                    return_quantity: e.target.checked,
                };
            }
            return product;
        });
        setProductInfo(updatedProducts)
    }
    const allReasonsFilled = productInfo.every(item => item.reason === "");
    const returnProduct = () => {
        const payload = {
            products: productInfo,
            pos_location: orderData?.pos_location,
            pos_customer: orderData?.pos_customer,
            channel: orderData?.channel,
            order: orderData?._id,
            refund_type: paymentMethod
        }
        dispatch(returnOrder(payload));
    }
    return (
        <div className='p-5 sm:min-w-[460px] flex flex-col gap-4'>
            <div className='flex items-center justify-between'>
                <h4>Refund Product</h4>
            </div>
            <hr className='main-border-color' />
            <form
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                method='post'
                className='w-full'
            >
                <div className='mb-4 relative input'>
                    <label>Product<span className='ms-1'></span></label>
                    <Autocomplete
                        multiple
                        className='autocomplete w-full'
                        options={filteredProduct}
                        value={selectedProduct}
                        getOptionLabel={(option) => option.name}
                        onChange={handleProduct}
                        filterSelectedOptions
                        renderInput={(brands) => (
                            <TextField
                                placeholder='Select Products'
                                className='cursor-pointer'
                                {...brands}
                            />
                        )}
                    />
                </div>
                <div className='mb-4'>
                    {productInfo?.map((elem, index) => (
                        <>
                            <div className='flex items-center mt-1 justify-between'>
                                <span className='inline-block font-semibold'>{elem?.name}</span>
                                <span className='inline-block font-semibold'>{FormatAmount((elem?.selling_price - (elem?.discount_amount || 0)), staffInfo?.client)}</span>
                                <div className='counter'>
                                    <button type='button' disabled={elem?.quantity === 1} className={`counter-btn ${elem?.quantity <= 1 && 'cursor-not-allowed opacity-50'}`} onClick={() => qtyCounter(elem, false)} ><MinusIcon className='w-3 h-3' /> </button>
                                    <input value={elem?.quantity} readOnly />
                                    <button type='button' disabled={elem?.quantity >= elem?.qty} className={`counter-btn ${elem?.quantity >= elem?.qty && 'cursor-not-allowed opacity-50'}`} onClick={() => qtyCounter(elem, true)}><PlusIcon className='w-3 h-3' /> </button>
                                </div>
                            </div>
                            <div className='mb-4 relative input'>
                                <label>Reason<span className='text-red-500 ms-1'>*</span></label>
                                <div className='select-wrapper'>
                                    <select className='w-full cursor-pointer' value={productInfo?.find((data) => data?.product === elem?.product)?.reason} onChange={(e) => handleReason(elem, e)} name='discount_Type'>
                                        <option value='' className='cursor-pointer'>Select Reason</option>
                                        <option className='cursor-pointer'>Unexpected Product</option>
                                        <option className='cursor-pointer'>Size Issues</option>
                                        <option className='cursor-pointer'>Late Delivery</option>
                                        <option className='cursor-pointer'>Damaged Delivery</option>
                                    </select>
                                    <div className='select-arrow'></div>
                                </div>
                            </div>
                            <div className='mb-4 relative input'>
                                <label>Feedback<span className='ms-1'></span></label>
                                <input
                                    type='text'
                                    className='input-secondary'
                                    value={productInfo?.find((data) => data?.product === elem?.product)?.comment}
                                    placeholder='Your Precious Feedback...'
                                    onChange={(e) => handleComment(elem, e)}
                                />
                                <svg xmlns="http://www.w3.org/2000/svg" className='customer-input-icon w-5 h-5' fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                                </svg>
                            </div>
                            <div className='mb-4'>
                                <label className='flex select-none normal-case items-center cursor-pointer'>
                                    <Checkbox
                                        checked={productInfo?.find((data) => data?.product === elem?.product)?.return_quantity}
                                        value={productInfo?.find((data) => data?.product === elem?.product)?.return_quantity}
                                        onChange={(e) => handleReturnQuantity(elem, e)}
                                    />
                                    Include In Stock
                                </label>
                            </div>
                            <hr className='main-border-color' />
                        </>
                    ))
                    }
                </div>
                <div className='mb-4'>
                    <label>Refund Type<span className='ms-1'></span></label>
                    <div className='flex items-center'>
                        <input type='radio' checked={paymentMethod === 'cash'} onChange={(e) => setPaymentMethod('cash')} />
                        <label className='!mb-0 ms-1'>Cash<span className='ms-1'></span></label>
                        <input type='radio' checked={paymentMethod === 'digital'} onChange={(e) => setPaymentMethod('digital')} />
                        <label className='!mb-0 ms-1'>Digital<span className='ms-1'></span></label>
                    </div>
                </div>
                <button type='button' onClick={() => { handleClosePopup(); returnProduct() }} disabled={allReasonsFilled} className={`${allReasonsFilled ? 'cursor-not-allowed opacity-50' : ''} btn-primary btn-lg text-[18px]`}>Submit</button>
            </form>
        </div>
    )
}

export default RefundProduct